import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { getUserJobs } from "../redux/Actions/AuthAction";

export const useUserJobs = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state: any) => state.auth);
  const [jobs, setJobs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadJobs = async () => {
    if (!user?.id) {
      setError("User not authenticated");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await dispatch(getUserJobs({
        userId: user.id,
        page: 1,
        limit: 50,
        filters: {
          status: [1, 2, 3, 4, 5, 6, 7, 8] // Using numeric values instead of enum
        },
        sort: [{ orderBy: "createdAt", order: "DESC" }],
        isShowLoader: false
      }));

      if (response.meta.requestStatus === "fulfilled") {
        const jobsData = response.payload.data || response.payload;
        setJobs(Array.isArray(jobsData) ? jobsData : []);
      } else {
        setError("Failed to load jobs");
      }
    } catch (err: any) {
      setError(err.message || "Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      loadJobs();
    }
  }, [user?.id, dispatch]);

  const refreshJobs = () => {
    loadJobs();
  };

  return {
    jobs,
    loading,
    error,
    refreshJobs
  };
};
